import LoadingUI from "./LoadingUI";

type ReadMoreProps = {
  onClick: React.MouseEventHandler<HTMLButtonElement>;
  isLoading: boolean;
};

/*
 * 追加読みこみボタン
 */
export default function ReadMore({ onClick, isLoading }: ReadMoreProps) {
  return (
    <>
      {isLoading ? (
        <LoadingUI
          parentClassName="h-20"
          spinClassName="size-5"
        />
      ) : (
        <div className="flex justify-center py-6">
          <button
            className="group relative flex items-center gap-3 overflow-hidden rounded-full border border-GRAY_3 bg-WHITE_1 px-8 py-3 text-sm font-medium text-GRAY_2 shadow-sm transition-all duration-300 hover:border-PRIMARY/40 hover:text-PRIMARY hover:shadow-md"
            onClick={onClick}
          >
            <span className="relative z-10">もっと見る</span>
            <span className="relative z-10 flex size-5 items-center justify-center transition-all duration-300">
              <svg
                className="size-3 transition-transform duration-300 group-hover:translate-y-0.5"
                viewBox="0 0 12 12"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 2v8M2 6l4 4 4-4"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </span>
            <span className="absolute inset-0 -z-0 bg-gradient-to-r from-PRIMARY/5 to-transparent opacity-0 transition-opacity duration-300 group-hover:opacity-100" />
          </button>
        </div>
      )}
    </>
  );
}
